// packages/shared-hooks/src/leads/useSubmitCallCenterLead.ts
//
// `POST /call-center/leads` (#1258) — external call-center agent lead
// intake. The accepted response is a deliberately minimal
// `{ accepted: true }` envelope (#1256): the external agent boundary must
// not leak any server-side lead state.
//
// WHY (#1398): the agent now sees a read-only table of their OWN accepted
// submissions (`useMyCallCenterLeads`). On a successful submit we invalidate
// the `myCallCenter` prefix so the new row appears without a reload. The
// envelope still carries no server-side state — only the list refetch does.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  CallCenterLeadIntakeAcceptedSchema,
  type CallCenterLeadIntakeAccepted,
  type CallCenterLeadIntakeSubmission,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { leadsKeys } from './keys.js';

export function useSubmitCallCenterLead() {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<CallCenterLeadIntakeAccepted, unknown, CallCenterLeadIntakeSubmission>({
    mutationFn: (input) =>
      client.post<CallCenterLeadIntakeAccepted>(
        '/call-center/leads',
        input,
        {},
        CallCenterLeadIntakeAcceptedSchema,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: leadsKeys.myCallCenter() });
    },
  });
}
